var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58415 19.0406H18.4234C19.6009 19.0406 20.3589 17.7986 19.8267 16.7502L11.407 1.83035C10.8262 0.669181 9.16504 0.669181 8.58437 1.83035L0.164747 16.7502C-0.351399 17.7986 0.40669 19.0406 1.58415 19.0406ZM11.3266 15.5727C11.3266 16.3469 10.762 16.9437 9.95555 16.9437C9.14907 16.9437 8.58453 16.3469 8.58453 15.5727V15.5405C8.58453 14.7662 9.14907 14.1695 9.95555 14.1695C10.762 14.1695 11.3266 14.7662 11.3266 15.5405V15.5727ZM9.21343 5.49176H10.7943C11.2296 5.49176 11.4879 5.86274 11.4395 6.33049L10.7457 12.3952C10.6973 12.8307 10.407 13.1049 10.0038 13.1049C9.60053 13.1049 9.3102 12.8307 9.26181 12.3952L8.56808 6.33049C8.51985 5.86274 8.77809 5.49176 9.21343 5.49176Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f8bfe709d4e2297f23d24ae8d8fbd998.svg";
export { ForwardRef as ReactComponent };